// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-prestige -> dietz-property-group-prestige -> colonial-gardens-apartments
// Generated: 2026-09-23T21:38:02.857Z
// Counts: 1 design, 14 content, 2 slot group, 2 collection binding, 7 section, 0 style

export const designOverrides = {
  "design.block:multihub-lead-form.color.primary": {
    "cssVariable": "--vibe-color-primary",
    "overrideType": "FIELD_MAPPING",
    "value": null,
    "mappedField": "property_secondary_color"
  }
};

export const contentOverrides = {
  "header.interactive_map_show_if_exists": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_engrain_sightmap_url"
  },
  "interactivemapsection.map_block": {
    "overrideType": "VALUE",
    "customValue": "engrain-sitemap",
    "generatedValue": null,
    "mappedField": null
  },
  "adtaxi-tracking.profile": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_adtaxi_domain"
  },
  "audioeye-widget.cta_color": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_primary_color"
  },
  "audioeye-widget.cta_location": {
    "overrideType": "VALUE",
    "customValue": "right-middle",
    "generatedValue": null,
    "mappedField": null
  },
  "google-tag-manager.container_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_google_gtm_id"
  },
  "knock-chatbot.api_token": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_knock_company_token"
  },
  "scheduletourform.form_block": {
    "overrideType": "VALUE",
    "customValue": "multihub-lead-form",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Explore affordable two- and three-bedroom apartment floor plans at Colonial Gardens in Georgetown, KY. Our LIHTC affordable housing community offers project-based Section 8 apartment homes for qualifying households. Applicants must meet applicable eligibility requirements, including an income limit of 60% of the Area Median Income (AMI). Housing Choice Vouchers are accepted.</p><p>Browse available floor plans and contact our leasing team to learn more about current availability and qualification requirements.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Affordable 2 &amp; 3 Bedroom Apartments in <span data-type=\"field-token\" data-field=\"property_address_city\"></span>, <span data-type=\"field-token\" data-field=\"property_address_state\"></span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Cats are allowed at this property: maximum weight 30 lb each. Pet deposit: $200 per cat. Monthly pet rent: $25 per cat. No dogs allowed. Maximum 2 animals per unit.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.pet_deposit_value": {
    "overrideType": "VALUE",
    "customValue": "200",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Welcome to Colonial Gardens, where affordable living meets everyday comfort in Georgetown, KY. Choose from spacious two- and three-bedroom apartments featuring in-unit laundry, private entrances, air conditioning, off-street parking, and a private patio or balcony.</p><p>Colonial Gardens participates in the Low-Income Housing Tax Credit (LIHTC) program and offers project-based Section 8 apartment homes. Applicants must meet applicable income and eligibility requirements, with an income limit of 60% of the Area Median Income (AMI). Housing Choice Vouchers are also accepted.</p><p>Explore our affordable apartments in Georgetown, KY, and contact our leasing team to learn more about current availability and income qualifications.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Affordable apartments in <span data-type=\"field-token\" data-field=\"property_address_city\"></span>, <span data-type=\"field-token\" data-field=\"property_address_state\"></span></p>",
    "generatedValue": null,
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "contactform.form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/thank-you"
      }
    }
  },
  "petscallout.image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/company/5767906449162273/019e85db-45c6-7570-8b98-f085354e1af6.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Woman holding a dog indoors."
      }
    }
  }
};

export const collectionBindingOverrides = {
  "communityamenitieslist.items": {
    "limit": null,
    "hiddenIds": [
      "ec_f657e565a031c041bb7fcec5",
      "ec_c649f7797824cb0c6bb39ba7",
      "ec_1be6d57cab939511aaef397b",
      "ec_a67bea85b6c5d2bdea57d6fc",
      "ec_263e846b59ad12cd53f27e11",
      "ec_e313a471d36659081744ba19",
      "ec_0be582d511ccab59111990b9",
      "ec_411f3db9e61f8f0cff190e31",
      "ec_26774e45d25e9a394f7b9231"
    ],
    "orderedIds": null,
    "hiddenIndices": [
      4,
      6,
      7,
      9,
      11,
      12,
      14,
      13,
      15
    ],
    "ordering": null,
    "customItems": null
  },
  "interioramenitieslist.items": {
    "limit": null,
    "hiddenIds": [
      "ec_ffd115f9f4d9c0c79cd35ace",
      "ec_21e9b9c21f4e62a61573f5a6"
    ],
    "orderedIds": null,
    "hiddenIndices": [
      13,
      14
    ],
    "ordering": null,
    "customItems": null
  }
};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    },
    {
      "sectionId": "adtaxi-tracking",
      "blockId": "adtaxi-tracking",
      "position": 0
    },
    {
      "sectionId": "audioeye-widget",
      "blockId": "audioeye-widget",
      "position": 0
    },
    {
      "sectionId": "knock-chatbot",
      "blockId": "knock-chatbot",
      "position": 0
    },
    {
      "sectionId": "realpage-calendar",
      "blockId": "realpage-calendar",
      "position": 0
    }
  ]
};

export const styleOverrides = {};
